import { CSSProperties } from 'react';
import { Box } from '@mui/material';

interface Props {
  value: string;
  color?: CSSProperties['color'];
}

const CostItem = ({ value, color }: Props) => <Box style={{ color }}>{value}</Box>;

export default CostItem;
